import { Text } from 'lucide-react';
import type { RichtextBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const richtextConfig: BlockTypeConfig<RichtextBlock> = {
  type: 'richtext',
  label: 'Rich Text',
  description: 'Formatted text with WYSIWYG editor',
  icon: Text,
  category: 'text',
  createDefault: () => ({
    html: '<p></p>',
  }),
  toolbar: [{ kind: 'variant' }],
  sheet: [],
};
